import { ScrollArea, Stack } from '@mantine/core';

import { Transit } from '@e-origin/shared';

import { TransitViewIncident } from './TransitViewIncident';

interface TransitViewIncidentsProps {
  transit: Transit;
}

export const TransitViewIncidentsCustoms = ({ transit }: TransitViewIncidentsProps) => {
  const incidents = transit?.customsState?.Incident || [];

  return (
    <ScrollArea h="100%" offsetScrollbars="y">
      <Stack mx="xl">
        {incidents.map((incident, incidentIdx) => (
          <TransitViewIncident incident={incident} index={incidentIdx} key={incidentIdx} />
        ))}
      </Stack>
    </ScrollArea>
  );
};
